<template>
  <div>
    <contact-support-options-dialog
      :show-contact-support-options="showContactSupportOptionsDialog"
      @onDialogClose="onContactSupportActionNotSelected"
      @onContactSupportAction="onContactSupportActionSelected">
    </contact-support-options-dialog>

    <contact-support-email-dialog
      :show="showEmailDialog"
      :subject="emailSubject"
      :body="emailBody"
      @sendMail="sendMail"
      @dialogClose="showEmailDialog=false">
    </contact-support-email-dialog>

    <send-email-item
      :send-mail-event="sendMailEvent"
      :send-email-request="sendEmailRequest"
      @sendMailEvent="onSendMailEvent">
    </send-email-item>
  </div>
</template>

<script>

  import ContactSupportOptionsDialog from "../dialogs/ContactSupportOptionsDialog";
  import ContactSupportEmailDialog from "../dialogs/ContactSupportEmailDialog";
  import SendEmailItem from "./SendEmailItem";
  import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
  import PrefManager from "@/data/model/PrefManager";
  import AlertService from "@/components/core/alert/AlertService";
  import { MessageConstants } from "@/utils/MessageConstantUtil";
  import { Constants } from '../Constants';
  import { environment } from "@/environments/environment";

  export default {
    name: "ContactSupportItem",
    components: { ContactSupportOptionsDialog, ContactSupportEmailDialog, SendEmailItem },
    props: {
      contactSupportActionsEvent: {
        type: Boolean,
        required: true,
        default: false,
      },

      emailTo: {
        type: Array,
        default: () => [environment.contactSupportEmail]
      },

      emailFrom: {
        type: String,
        default: environment.noReplyEmail
      },

      emailSubject: {
        type: String,
        default: ''
      },

      emailBody: {
        type: String,
        default: ''
      }
    },

    methods: {
      onContactSupportActionSelected(action) {
        this.showContactSupportOptionsDialog = false;
        if (action === "email") {
          this.showEmailDialog = true;
        } else {

        }
        this.$emit("resetContactSupportEvent", {})
      },

      onContactSupportActionNotSelected() {
        this.showContactSupportOptionsDialog = false;
        this.$emit("resetContactSupportEvent", {})
      },

      sendMail(e) {
        this.showEmailDialog = false;
        this.sendEmailRequest = {
          'to': this.emailTo,
          'from': this.emailFrom,
          'subject': `Need Support in weex app: ${e.subject}`,
          'body': `${this.getUserDescription()} \n ${this.getLoanDescription()} \n Message By User: ${e.body}`
        };
        this.sendMailEvent = true;
      },

      onSendMailEvent(sendEmailRes) {
        this.sendMailEvent = false;
        if (sendEmailRes.errorOccurred) {
          AlertService.showToast(MessageConstants.EMAIL_NOT_SENT);
        } else {
          AlertService.showToast(MessageConstants.EMAIL_SENT);
        }
      },

      getUserDescription() {
        let appUserDetails = "App User Details :";
        appUserDetails = appUserDetails + " User Id = " + PrefManager.getUserId();
        appUserDetails = appUserDetails + " User Mobile = " + PrefManager.getUserMobile();
        return appUserDetails;
      },

      getLoanDescription() {
        let loanDetails = "Loan Details :";
        loanDetails = loanDetails + " Client Id = " + LoanScopeDataHolder.getClientId();
        loanDetails = loanDetails + " Loan Id = " + LoanScopeDataHolder.getLoanId();
        loanDetails = loanDetails + " Mobile = " + LoanScopeDataHolder.getMobile();
        if (LoanScopeDataHolder.getCurrentLoanTask()) {
          loanDetails = loanDetails + " Task = " + LoanScopeDataHolder.getCurrentLoanTask().name;
        }

        return loanDetails;
      }
    },
    data: () => ({
      showContactSupportOptionsDialog: false,
      showEmailDialog: false,
      sendMailEvent: false,
      sendEmailRequest: {},
    }),

    watch: {
      contactSupportActionsEvent() {
        if (this.contactSupportActionsEvent) {
          this.showContactSupportOptionsDialog = true;
        }
      }
    }
  };
</script>

<style scoped>

</style>